import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initAccountLogin from '../sections/account/account-login';
import initAddressCountryProvince from '../sections/account/address-country-province';
import initAccountAddressForm from '../sections/account/account-address-form';
import initProductStrengthModal from '../components/product-strength-modal';

ready(() => {
  initAccountLogin();
  initAccountAddressForm();
  initAddressCountryProvince();
  initProductStrengthModal();
});

onShopifySectionLoad(() => {
  initAccountLogin();
  initAccountAddressForm();
  initAddressCountryProvince();
  initProductStrengthModal();
});
